import {Navigate, useSearchParams} from 'react-router-dom';
import {getSafeReturnTo} from '@/lib/auth-return';
import {useAuth} from '@/contexts/AuthContext';

interface RedirectIfAuthProps {
    children: React.ReactNode;
}

export function RedirectIfAuth({children}: RedirectIfAuthProps) {
    const {isAuthenticated, isLoading} = useAuth();
    const [searchParams] = useSearchParams();

    if (isLoading) {
        return (
            <div className="flex min-h-screen items-center justify-center">
                <div className="size-12 animate-spin rounded-full border-b-2 border-gray-900"></div>
            </div>
        );
    }

    if (isAuthenticated) {
        return <Navigate to={getSafeReturnTo(searchParams.get('returnTo'))} replace />;
    }

    return <>{children}</>;
}
